import { Box } from "@mui/joy";
import { useFormContext, useWatch } from "react-hook-form";

export const useIsMultipleValuesSelected = (fieldName: string) => {
  const [fieldsWithMultipleValues, value] = useWatch({
    name: ["_fieldsWithMultipleValues", fieldName],
  }) as [string[] | undefined, unknown | null];

  // Get the form state
  const {
    formState: { touchedFields },
  } = useFormContext();

  // Check if the field has been touched
  const isTouched = touchedFields[fieldName];

  return !isTouched && fieldsWithMultipleValues?.includes(fieldName) && value === null;
};

export const MultipleValuesSelectedIndicator = ({ name }: { name: string }) => {
  const isMultipleValuesSelected = useIsMultipleValuesSelected(name);
  return isMultipleValuesSelected ? (
    <Box
      sx={{
        color: "var(--joy-palette-neutral-600)",
        marginTop: "-6px",
        marginBottom: "8px",
        display: "block",
      }}
    >
      (Multiple values selected)
    </Box>
  ) : null;
};

export default MultipleValuesSelectedIndicator;
